var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _g2, _path19, _path20, _path21, _g3, _g4, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 261,
    height: 260,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M229.993 223.429c-5.319 5.594-10.352 9.203-14.328 12.053-46.742 33.505-102.05 23.737-113.804 21.353-17.358-3.522-50.91-10.33-75.167-38.829-36.7-43.116-30.985-111.042-2.519-155.889 5.207-8.203 32.708-53.726 88.616-61.026 33.832-4.418 73.269 4.494 101.829 28.397 59.949 50.18 55.682 151.547 15.373 193.941"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#91B3FA",
    d: "M181.374 149.726s-.659-27.729 12.112-35.151 37.056-12.062 37.966-51.878c.533-23.31 1.11-33.503 1.497-37.947a2.63 2.63 0 0 0-1.901-2.757 2.6 2.6 0 0 0-1.199-.054c-12.097 2.282-51.391 11.66-59.629 38.482-9.767 31.796 11.154 89.305 11.154 89.305"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M220.496 33.02c-13.276 11.843-28.631 32.8-36.814 53.758-1.051 3.454-4.123 10.799-5.458 23.85-1.188 10.884-.599 22.385.843 29.999a.886.886 0 0 0 1.037.703c.828-.156.717-1.047.71-1.015-1.651-13.008-.966-29.198 2.816-43.806 4.831-17.938 15.608-35.328 26.753-50.079l1.147-1.452c8.635-11.09 10.453-11.172 9.647-11.948a.507.507 0 0 0-.681-.01",
    opacity: 0.34
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDD0FB",
    d: "M160.849 203.042c-1.729.848 16.359-21.897 22.022-57.618 2.669-16.833 2.704-37.923 12.293-46.05 7.98-6.765 35.137-2.495 44.022-.871a1.332 1.332 0 0 1 .62 2.331c-4.26 3.578-13.376 12.019-15.751 20.526-3.131 11.213-13.791 18.345-23.335 20.276-9.544 1.93-14.852 3.803-19.501 19.065s-15.461 39.934-20.37 42.341"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M226.693 103.239c-11.337.475-23.507 5.646-29.682 15.347l-.582.925c-1.346 2.171-8.976 17.6-13.213 30.39a.306.306 0 0 0 .193.385.31.31 0 0 0 .38-.183c2.953-7.225 7.193-16.386 10.57-23.236 3.622-7.475 6.156-12.538 14.417-17.387 9.194-5.222 17.978-5.76 17.952-5.755a.243.243 0 0 0 .142-.427.24.24 0 0 0-.177-.059",
    opacity: 0.56
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#91B3FA",
    d: "M168.602 206.031c-1.026.54 5.779-11.168 6.297-21.48.519-10.312 2.849-27.917 11.743-38.447s18.634-11.491 30.907-1.918c10.23 7.977 16.607 12.003 20.349 12.751.926.186 1.398 1.231.948 2.061-2.4 4.42-9.184 14.571-20.576 13.856-14.53-.912-32.14-10.358-37.507-2.478-5.368 7.88-4.678 12.289-4.842 16.023s-.53 16.057-7.319 19.632"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M220.411 156.831c-5.289-4.267-13.901-8.46-21.43-7.679-9.795 1.328-16.322 6.834-19.878 15.028-1.392 3.479-1.964 5.337-2.787 9.602-.065.34.531.442.631.11.598-2.003 1.191-4.101 2.078-6.271 5.162-13.997 16.183-15.882 16.612-16.166.833.07 5.883-3.113 17.868 2.315a55 55 0 0 1 6.462 3.487l.011.007a.376.376 0 0 0 .468-.057.251.251 0 0 0-.035-.376",
    opacity: 0.34
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M65.422 34.132c-.692 32.627-2.934 145.166-1.863 185.047.113 4.225 3.008 7.616 6.62 7.754 17.862.684 83.343 2.417 112.559.983 6.085-.298 10.925-6.065 11.051-13.188.607-34.245 1.947-130.564-1.237-174.688-.381-5.287-3.928-9.497-8.441-10.025-19.453-2.273-85.215-7.842-110.457-5.925-4.552.345-8.118 4.707-8.232 10.042"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#7FE7DD",
    d: "M73.39 44.142c-.96 26.334-3.993 113.939-3.031 146.337.141 4.735 3.33 8.564 7.375 8.84 16.646 1.14 73.44 3.653 97.856 1.365 4.397-.411 7.848-4.571 8.082-9.725 1.238-26.865 4.79-108.442 3.868-140.475-.148-5.11-3.531-9.283-7.887-9.74-18.004-1.89-78.355-6.39-99.103-5.065-3.895.248-6.99 3.904-7.16 8.463"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M109.568 29.79c0 1.001.667 1.827 1.521 1.88 4.217.258 16.104.989 21.415 1.35 1.047.07 1.87-1.03 1.67-2.236l-.033-.205c-.136-.822-.719-1.442-1.432-1.518-3.592-.384-14.424-1.452-21.601-1.152-.862.036-1.54.871-1.54 1.881",
    opacity: 0.54
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M124.984 119.588c18.866 0 34.161-15.295 34.161-34.162s-15.295-34.161-34.161-34.161c-18.867 0-34.162 15.294-34.162 34.161s15.295 34.162 34.162 34.162"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E0292",
    d: "m134.81 87.591-1.77-7.362a4.86 4.86 0 0 0-4.69-3.734l-6.206-.054-6.253-.054a4.81 4.81 0 0 0-4.746 3.704l-1.647 7.455c-2.309.51-3.949 2.33-3.949 4.494v8.044c0 .769.721 1.531 1.601 1.524l2.078-.014v3.718c0 1.163.832 2.1 1.999 2.087l1.43-.016a2.126 2.126 0 0 0 2.091-2.128v-3.705l14.982-.116v3.67c0 1.148.77 2.076 1.907 2.062l1.298-.015a2.097 2.097 0 0 0 2.052-2.101v-3.656l1.975-.014c.845-.006 1.705-.762 1.705-1.514v-7.873c0-2.114-1.675-3.892-3.857-4.402m-20.249-6.615c.143-.605.689-1 1.327-.996l6.252.04 6.202.04c.625 0 1.164.4 1.305 1.003l1.501 6.403-18.123-.027zm-2.457 16.464a3.064 3.064 0 0 1-.598-6.07 3.066 3.066 0 1 1 .598 6.07m19.945-.1a3.03 3.03 0 0 1-2.82-1.84 3.03 3.03 0 0 1 .629-3.308 3.026 3.026 0 0 1 5.18 2.115 2.99 2.99 0 0 1-1.836 2.8 3 3 0 0 1-1.153.234M154.452 80.385c-.671-3.96-1.345-7.888-2.018-11.856a.89.89 0 0 0-.892-.744l-10.178-.148a.875.875 0 0 0-.904.724l-2.056 11.941a1.277 1.277 0 0 0 .252.993c.216.263.536.464.872.469l13.823.073c.33 0 .644-.204.859-.46a1.3 1.3 0 0 0 .242-.992"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#7FE7DD",
    d: "M146.472 72.779c-2.087-.024-3.789-1.988-3.789-4.374s1.702-4.306 3.789-4.27c2.087.034 3.77 1.998 3.77 4.372 0 2.375-1.689 4.295-3.77 4.271m0-7.62c-1.53-.026-2.777 1.435-2.777 3.256 0 1.822 1.249 3.318 2.777 3.336s2.766-1.443 2.766-3.258-1.239-3.31-2.766-3.335"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M170.657 130.625H89.844a.86.86 0 0 0-.86.859v9.847a.86.86 0 0 0 .86.859h80.813a.86.86 0 0 0 .859-.859v-9.847a.86.86 0 0 0-.859-.859M177.007 153.23H82.973a.82.82 0 0 0-.82.82v10.451c0 .453.368.82.82.82h94.034a.82.82 0 0 0 .82-.82V154.05a.82.82 0 0 0-.82-.82",
    opacity: 0.57
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m183.866 152.858-7.572-.644 14.174 84.513h8.481a2.714 2.714 0 0 0 2.635-2.069c.095-.392.102-.8.02-1.194l-16.569-79.57a1.31 1.31 0 0 0-1.169-1.036"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CEBC",
    d: "M213.312 190.038c-.006-.156-.696-15.942-7.593-21.625-2.044-1.684-4.458-2.324-7.174-1.903-5.72.884-9.676 5.092-11.758 12.505-1.561 5.569-1.418 10.951-1.416 11.005l-.526.016c0-.055-.15-5.506 1.433-11.152.937-3.329 2.278-6.077 3.996-8.168 2.16-2.63 4.916-4.217 8.19-4.727 2.872-.444 5.426.235 7.59 2.018 2.979 2.455 5.193 6.909 6.585 13.24a56.4 56.4 0 0 1 1.199 8.77z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CEBC",
    d: "m163.246 233.887 6.991-46.076a.91.91 0 0 1 .886-.775l40.393-.668 8.737 52.02h-53.572c-2.268-.003-3.766-2.253-3.435-4.501"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#7FE7DD",
    d: "m219.305 187.028-7.787-.663 8.737 52.02 8.625-.222a1.36 1.36 0 0 0 1.291-1.049c.047-.194.049-.396.009-.591l-10.27-49a.7.7 0 0 0-.225-.342.7.7 0 0 0-.38-.153M204.604 189.871c-.006-.157-.697-15.943-7.593-21.626-2.044-1.683-4.458-2.324-7.175-1.903-5.719.885-9.675 5.092-11.757 12.506-1.562 5.568-1.419 10.951-1.416 11.004l-.527.016c0-.054-.15-5.505 1.433-11.152.938-3.329 2.278-6.076 3.996-8.168 2.161-2.629 4.917-4.217 8.19-4.727 2.873-.444 5.427.235 7.591 2.019 2.978 2.454 5.193 6.908 6.584 13.239a56 56 0 0 1 1.2 8.771z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#91B3FA",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.755 59.503a.666.666 0 0 1-.83-.324c-.336-.672-.649-1.37-.93-2.069a.666.666 0 0 1 .37-.863l.012-.005a.666.666 0 0 1 .853.376c.267.666.564 1.328.885 1.966a.665.665 0 0 1-.296.893zm-2.01-5.437q-.036.014-.077.023a.666.666 0 0 1-.806-.484 27 27 0 0 1-.454-2.222.665.665 0 1 1 1.314-.211c.113.703.258 1.415.43 2.108a.665.665 0 0 1-.406.786m-.761-5.745a.664.664 0 0 1-.9-.61c-.016-.752 0-1.515.053-2.264a.666.666 0 1 1 1.328.089 25 25 0 0 0-.052 2.154.665.665 0 0 1-.43.631m.54-5.77a.666.666 0 0 1-.888-.76c.156-.738.343-1.477.56-2.199a.665.665 0 0 1 1.274.383 26 26 0 0 0-.531 2.089.66.66 0 0 1-.414.486m1.816-5.506a.664.664 0 0 1-.84-.9c.313-.683.661-1.364 1.033-2.02a.667.667 0 0 1 1.114-.094.67.67 0 0 1 .044.749c-.353.625-.684 1.27-.982 1.92a.66.66 0 0 1-.37.345m2.988-4.967a.665.665 0 0 1-.765-1.026c.458-.599.947-1.185 1.453-1.742a.665.665 0 0 1 .985.895c-.482.53-.946 1.086-1.38 1.655a.66.66 0 0 1-.293.218m22.245-10.102a.7.7 0 0 1-.278.041 25 25 0 0 0-2.155-.047.665.665 0 0 1-.028-1.328c.755-.015 1.518 0 2.27.05a.666.666 0 0 1 .19 1.288zM47.339 27.9a.666.666 0 0 1-.661-1.135c.58-.48 1.187-.943 1.805-1.373a.665.665 0 1 1 .76 1.093c-.588.408-1.164.846-1.714 1.303a.7.7 0 0 1-.19.112m12.445-5.646a.6.6 0 0 1-.13.034c-.706.115-1.416.261-2.108.435a.665.665 0 1 1-.324-1.29c.732-.183 1.48-.338 2.223-.458a.666.666 0 0 1 .342 1.279zm-7.601 2.468a.666.666 0 0 1-.534-1.216c.671-.34 1.366-.655 2.066-.937l.013-.005a.665.665 0 0 1 .484 1.24 25 25 0 0 0-2.03.92zM70.188 22.702a.66.66 0 0 1-.397.022 28 28 0 0 0-1.01-.234.665.665 0 1 1 .271-1.303c.355.075.713.156 1.064.245a.666.666 0 0 1 .072 1.268z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#91B3FA",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.37 34.935a.665.665 0 0 1-.812-.292q-.256-.447-.534-.889a.664.664 0 0 1 .447-1.023.665.665 0 0 1 .68.315c.193.308.382.625.562.937a.666.666 0 0 1-.343.952M73.083 72.064q-.43.163-.868.313a.666.666 0 0 1-.428-1.261 26 26 0 0 0 1.979-.764.666.666 0 1 1 .53 1.22c-.396.172-.804.337-1.214.492m-4.263 1.212a1 1 0 0 1-.11.031c-.728.142-1.47.254-2.207.335a.665.665 0 0 1-.144-1.323A26 26 0 0 0 68.457 72a.666.666 0 0 1 .363 1.275m8.583-3.321a.666.666 0 0 1-.581-1.191 25 25 0 0 0 1.761-1.179.665.665 0 0 1 .786 1.074c-.599.438-1.223.86-1.855 1.241a.6.6 0 0 1-.111.055m-14.27 3.786a.7.7 0 0 1-.254.042 30 30 0 0 1-2.227-.156.665.665 0 0 1 .15-1.322q1.058.118 2.116.152a.666.666 0 0 1 .215 1.288zm18.778-7.275a.664.664 0 0 1-.698-1.1c.504-.49.996-1.007 1.459-1.538a.667.667 0 0 1 1.104.136.67.67 0 0 1-.102.738 26 26 0 0 1-1.536 1.62.7.7 0 0 1-.227.145zm3.635-4.393a.665.665 0 0 1-.792-.983c.39-.59.753-1.202 1.093-1.82a.666.666 0 0 1 1.171.636c-.353.65-.74 1.294-1.146 1.915a.66.66 0 0 1-.326.253zm2.59-5.081a.666.666 0 0 1-.86-.86c.25-.659.475-1.336.668-2.012a.665.665 0 1 1 1.28.365c-.204.712-.44 1.425-.703 2.119a.67.67 0 0 1-.385.39zm1.42-5.524a.665.665 0 0 1-.894-.717c.1-.698.17-1.405.21-2.108a.666.666 0 1 1 1.328.078 27 27 0 0 1-.221 2.222.66.66 0 0 1-.423.526zm.173-5.701a.663.663 0 0 1-.899-.569 25 25 0 0 0-.26-2.103.665.665 0 1 1 1.312-.22c.123.732.215 1.477.274 2.215a.664.664 0 0 1-.428.675zm-1.084-5.598-.038.013a.666.666 0 0 1-.833-.439 28 28 0 0 0-.711-1.998.666.666 0 1 1 1.234-.498q.11.274.215.547c.192.51.372 1.033.533 1.553a.666.666 0 0 1-.4.82zM57.469 72.939a.67.67 0 0 1-.4.022c-.349-.09-.703-.189-1.051-.294a.666.666 0 1 1 .383-1.274c.331.1.667.193.999.278a.665.665 0 0 1 .069 1.268"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#91B3FA",
    d: "M55.58 65.403a.31.31 0 0 0 .36-.034l2.862-2.478a16.5 16.5 0 0 0 5.295.703l2.109 3.137a.31.31 0 0 0 .338.127l4.386-1.172a.31.31 0 0 0 .235-.278l.27-3.772a16.5 16.5 0 0 0 4.241-3.248l3.715.726a.31.31 0 0 0 .329-.15l2.275-3.928a.31.31 0 0 0-.034-.36l-2.478-2.86c.52-1.715.758-3.503.703-5.295l3.138-2.108a.31.31 0 0 0 .126-.338l-1.171-4.387a.31.31 0 0 0-.278-.23l-3.773-.27a16.5 16.5 0 0 0-3.247-4.242l.726-3.714a.31.31 0 0 0-.15-.329l-3.928-2.275a.31.31 0 0 0-.36.034l-2.861 2.48a16.5 16.5 0 0 0-5.295-.703l-2.108-3.137a.31.31 0 0 0-.339-.128l-4.386 1.172a.31.31 0 0 0-.234.279l-.27 3.771a16.5 16.5 0 0 0-4.236 3.243l-3.715-.726a.31.31 0 0 0-.328.15l-2.278 3.925a.31.31 0 0 0 .035.359l2.477 2.861a16.5 16.5 0 0 0-.703 5.294l-3.138 2.109a.31.31 0 0 0-.126.338l1.171 4.386a.31.31 0 0 0 .278.23l3.767.276a16.5 16.5 0 0 0 3.248 4.241l-.726 3.714a.31.31 0 0 0 .15.329z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDD0FB",
    d: "M65.213 51.286a4.57 4.57 0 1 1-3.237-8.546 4.57 4.57 0 0 1 3.237 8.546m-2.84-7.547a3.484 3.484 0 1 0 2.47 6.517 3.484 3.484 0 0 0-2.47-6.517"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDD0FB",
    d: "M67.633 57.419a12 12 0 0 1-1.453.44c-.584.136-1.179.226-1.777.267h-.025l-.069.005-.134.007a.266.266 0 0 1-.28-.25.27.27 0 0 1 .254-.278 10.688 10.688 0 1 0-3.255-21.007c-5.701 1.518-9.093 7.385-7.575 13.079q.138.525.328 1.034a10.7 10.7 0 0 0 2.545 3.88q.043.041.063.096a.266.266 0 0 1-.434.285 11.24 11.24 0 0 1-3.02-5.154c-1.59-5.983 1.979-12.143 7.952-13.735a11.223 11.223 0 0 1 13.732 7.952 11.223 11.223 0 0 1-6.852 13.379"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#91B3FA",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.718 83.928a.41.41 0 0 1-.473-.136q-.317-.42-.608-.86a.411.411 0 0 1 .684-.455q.278.417.58.818a.41.41 0 0 1-.183.633M24.05 81.242a.41.41 0 0 1-.513-.2 18 18 0 0 1-.855-2.015.426.426 0 0 1 .25-.525.41.41 0 0 1 .524.25 17 17 0 0 0 .816 1.922.406.406 0 0 1-.223.568m-1.424-4.022a.412.412 0 0 1-.547-.295 18 18 0 0 1-.343-2.16.412.412 0 0 1 .819-.078q.1 1.04.326 2.06a.41.41 0 0 1-.253.473zm-.407-4.247a.411.411 0 0 1-.555-.397q.033-1.096.2-2.18a.41.41 0 1 1 .812.126q-.16 1.033-.19 2.078a.41.41 0 0 1-.264.373zm.651-4.218a.42.42 0 0 1-.4-.062.41.41 0 0 1-.14-.434q.3-1.055.727-2.064a.41.41 0 1 1 .756.32q-.406.962-.692 1.968a.41.41 0 0 1-.249.272zm1.661-3.93a.411.411 0 0 1-.501-.59q.548-.947 1.207-1.82a.41.41 0 0 1 .735.188.4.4 0 0 1-.078.305 17 17 0 0 0-1.15 1.74.4.4 0 0 1-.21.177zm2.564-3.408a.411.411 0 0 1-.441-.67 18 18 0 0 1 1.613-1.475.411.411 0 0 1 .516.64q-.81.657-1.532 1.409a.4.4 0 0 1-.156.096m3.322-2.673a.41.41 0 0 1-.362-.734q.932-.577 1.928-1.035a.412.412 0 0 1 .343.747q-.949.436-1.838.987a1 1 0 0 1-.071.035m5.95-2.305a.4.4 0 0 1-.07.02q-.893.168-1.764.43l-.26.078a.41.41 0 0 1-.516-.266.406.406 0 0 1 .266-.517q.138-.044.275-.085a18 18 0 0 1 1.846-.45.41.41 0 0 1 .222.788z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#91B3FA",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.916 89.61a.41.41 0 0 1-.295-.767q.954-.376 1.857-.864a.41.41 0 1 1 .39.723 18 18 0 0 1-1.952.907zm-2 .65-.041.014q-1.043.27-2.109.415a.411.411 0 0 1-.11-.814 17 17 0 0 0 2.015-.397.411.411 0 0 1 .249.781zm5.691-2.645a.41.41 0 0 1-.383-.72 17 17 0 0 0 1.593-1.286.41.41 0 0 1 .554.608q-.796.726-1.675 1.35a.4.4 0 0 1-.093.048zm-9.851 3.202a.4.4 0 0 1-.14.026 18 18 0 0 1-2.15-.107.411.411 0 1 1 .09-.817q1.021.114 2.05.102a.411.411 0 0 1 .15.796m12.95-6.034a.41.41 0 0 1-.457-.652q.67-.78 1.24-1.635a.411.411 0 0 1 .683.457q-.6.899-1.306 1.72a.4.4 0 0 1-.164.113zm2.33-3.49a.413.413 0 0 1-.513-.57q.463-.916.814-1.884a.412.412 0 0 1 .668-.17.41.41 0 0 1 .105.45 18 18 0 0 1-.853 1.976.4.4 0 0 1-.225.202zm1.423-3.944a.41.41 0 0 1-.547-.477q.231-1.002.338-2.024a.41.41 0 1 1 .818.085 18 18 0 0 1-.355 2.124.41.41 0 0 1-.254.292M35.56 90.353a.4.4 0 0 1-.24.015 16 16 0 0 1-1.015-.273.413.413 0 0 1-.286-.513.41.41 0 0 1 .52-.274c.313.095.642.183.969.26a.412.412 0 0 1 .049.781z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#91B3FA",
    d: "M34.003 85.266a.21.21 0 0 0 .24-.023l1.915-1.657a11 11 0 0 0 3.543.472l1.413 2.1a.21.21 0 0 0 .226.084l2.935-.78a.21.21 0 0 0 .157-.187l.18-2.524a11 11 0 0 0 2.839-2.174l2.486.486a.21.21 0 0 0 .22-.1l1.522-2.629a.21.21 0 0 0-.023-.24l-1.658-1.914c.348-1.148.506-2.345.469-3.543l2.1-1.414a.21.21 0 0 0 .084-.225l-.78-2.936a.21.21 0 0 0-.187-.156l-2.524-.18a11 11 0 0 0-2.173-2.838l.486-2.486a.21.21 0 0 0-.1-.22l-2.629-1.522a.21.21 0 0 0-.24.023l-1.915 1.655a11 11 0 0 0-3.546-.469l-1.413-2.1a.21.21 0 0 0-.226-.084l-2.936.78a.21.21 0 0 0-.156.187l-.181 2.524a11 11 0 0 0-2.838 2.174l-2.48-.486a.21.21 0 0 0-.22.1l-1.523 2.629a.21.21 0 0 0 .023.24l1.658 1.914a11 11 0 0 0-.472 3.543l-2.1 1.414a.21.21 0 0 0-.085.226l.781 2.935a.21.21 0 0 0 .187.156l2.524.181a11 11 0 0 0 2.173 2.838l-.485 2.486a.21.21 0 0 0 .1.22z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDD0FB",
    d: "M40.467 75.874a3.124 3.124 0 1 1-2.21-5.844 3.124 3.124 0 0 1 2.21 5.844m-1.9-5.05q-.158.06-.305.14a2.287 2.287 0 1 0 2.223 3.997 2.287 2.287 0 0 0-1.919-4.139z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDD0FB",
    d: "M42.142 80.143a7.81 7.81 0 0 1-2.306.491h-.071a.411.411 0 0 1-.04-.82q.74-.036 1.456-.227l.078-.02a6.85 6.85 0 0 0 4.096-3.143l.008-.014.023-.04a6.87 6.87 0 0 0 .485-5.928 6.92 6.92 0 0 0-13.155 4.245q.09.34.215.67a6.9 6.9 0 0 0 1.648 2.51.411.411 0 0 1-.573.59 7.7 7.7 0 0 1-2.084-3.56 7.74 7.74 0 1 1 14.363 1.54 7.75 7.75 0 0 1-4.143 3.706"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M75.704 139.38s-6.326 14.595-10.217 12.651-6.811-18.003-6.811-18.003 12.163-2.919 17.028 5.352"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M53.682 229.952s-.529 2.993-.788 5.956a2.04 2.04 0 0 0 1.952 2.212c3.946.164 12.387.484 15.415.349a.66.66 0 0 0 .63-.601.66.66 0 0 0-.045-.309 1.48 1.48 0 0 0-.76-.801l-13.943-6.404z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "m53.25 228.194.424 3.579s2.442 1.137 4.11-.143l-1.015-3.989z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M53.57 160.882c-.184.938-.985 46.659 3.904 67.148a.7.7 0 0 1-.407.809c-.75.306-2.22.75-3.983.809a1.2 1.2 0 0 1-1.189-.859c-1.397-4.753-8.091-28.573-8.964-51.326-.976-25.425 0-.866 0-.866l.572-15.716z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M37.643 231.514s-.842 1.511-1.657 5.526a1.25 1.25 0 0 0 1.094 1.492c1.303.128 3.309.293 4.92.282a1.25 1.25 0 0 0 .924-.418 1.24 1.24 0 0 0 .305-.967c-.178-1.466-.733-3.871-2.445-5.745z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "m36.906 226.909.992 5.415s.981.73 2.922.201l-.473-5.826z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M34.224 162.286c-3.998 24.123.867 59.623 2.508 66.572a1.08 1.08 0 0 0 .874.822c.733.122 1.938.221 3.124-.124a.99.99 0 0 0 .714-.914c.22-5.618-.176-40.104 3.548-53.733.19-.69.611-1.293 1.194-1.708l7.23-5.138.554-8.308z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M60.135 117.486C45.54 116.026 34.5 119.72 34.5 119.72c-3.57 20.836-.625 44.867-.625 44.867 9.274 2.432 19.736-1.484 19.736-1.484 1.54-8.708 8.732-33.217 8.732-33.217 5.853-.73 1.47-12.032-2.207-12.4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M49.843 142.235s-13.276 7.193-17.517 1.131c-.88-1.259-1.269-2.949-1.052-4.139-3.766-1.901-7.287-2.211-9.4-2.367-.556 2.906.32 6.092 2.014 9.226 6.53 12.075 27.618-.75 27.618-.75z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "m57.068 144.373 4.489-15.676a.457.457 0 0 1 .39-.33c.814-.094 3.17-.36 5.89-.591 3.28-.277 7.085-.502 9.359-.312a.46.46 0 0 1 .422.444.46.46 0 0 1-.047.216c-1.293 2.617-6.613 13.26-9.278 16.747a.47.47 0 0 1-.37.182l-10.414-.097a.45.45 0 0 1-.366-.182.46.46 0 0 1-.075-.401"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M51.27 145.416a1.3 1.3 0 0 1-1.508-1.035c-.255-1.265-.599-3.336-.34-4.27.385-1.393 1.131-3.184 3.62-2.786 2.487.398 5.422 1.446 5.422 1.446s-.148 1.815-2.039 1.23l1.172.907s-.168 1.453-1.765.677l1.093 1.203s-.686 1.194-1.861.428c-1.007-.655-1.565 1.781-3.794 2.2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M75.483 139.588s2.895-2.82 3.31-4.205c.413-1.384.732-3.299-1.588-4.284-2.319-.985-5.362-1.656-5.362-1.656s-.84 1.617 1.074 2.125l-1.475.146s-.63 1.32 1.136 1.511l-1.562.44s-.053 1.376 1.348 1.352.044 3.202 3.119 4.571"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "m49.02 107.756-3.807 11.022a.396.396 0 0 0 .18.479c1.04.574 4.783 2.235 9.294-.625a1.87 1.87 0 0 0 .86-1.335l1.233-9.54z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M57.315 97.549s4.186 7.879 3.649 11.061-5.724 2.954-10.253.369l-3.166-8.507z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M50.912 104.801a.321.321 0 0 0 .141-.474c-.335-.513-.963-1.562-1.164-2.473 0 0-.752-.482 1.915-1.121 2.668-.638 6.646-1.63 7.482-3.9.815-2.214-1.328-7.78-4.744-3.344a.324.324 0 0 1-.515 0c-.56-.729-2.03-2.242-4.077-1.328-1.914.86-2.129 2.265-2.103 2.968a.322.322 0 0 1-.383.33c-.967-.184-3.288-.343-4.373 2.038-.893 1.962-.313 3.072.216 3.615a.323.323 0 0 1-.139.538c-.636.195-1.456.734-1.374 2.224.113 2.059 2.416 1.874 3.071 1.783a.3.3 0 0 1 .157.016q.076.026.132.087c.561.624 3.094 3.262 5.835 3.581a.328.328 0 0 0 .344-.433l-1.186-3.448a.324.324 0 0 1 .176-.404z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M51.386 105.29s-2.98-2.045-3.197-.323 2.683 2.494 4.12 1.852z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "m39.092 131.32-4.594-11.599s-10.543 7.162-12.843 16.399a.75.75 0 0 0 .65.92c2.205.235 5.58.859 8.89 2.532.828-4.554 7.897-8.252 7.897-8.252"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 293.701,
    x2: 62.4,
    y1: 336.738,
    y2: 49.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 254.473,
    x2: 144.029,
    y1: 130.293,
    y2: 127.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 109.568,
    x2: 134.204,
    y1: 30.439,
    y2: 30.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 278.594,
    x2: 250.194,
    y1: 95.728,
    y2: 126.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 58.675,
    x2: 75.704,
    y1: 142.868,
    y2: 142.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 61.59,
    x2: 61.953,
    y1: 203.92,
    y2: 243.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 53.249,
    x2: 57.784,
    y1: 229.94,
    y2: 229.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 48.127,
    x2: 51.221,
    y1: 247.196,
    y2: 164.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 39.296,
    x2: 39.66,
    y1: 204.122,
    y2: 244.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 36.906,
    x2: 40.82,
    y1: 229.708,
    y2: 229.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 40.471,
    x2: 43.566,
    y1: 246.91,
    y2: 163.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 50.55,
    x2: 26.991,
    y1: 124.321,
    y2: 186.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 21.707,
    x2: 51.506,
    y1: 144.059,
    y2: 144.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 63.453,
    x2: 97.639,
    y1: 138.368,
    y2: 100.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 49.33,
    x2: 58.464,
    y1: 141.354,
    y2: 141.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 78.83,
    x2: 71.065,
    y1: 136.032,
    y2: 131.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 45.187,
    x2: 56.779,
    y1: 114.007,
    y2: 114.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 59.962,
    x2: 47.141,
    y1: 107.647,
    y2: 99.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 40.353,
    x2: 56.918,
    y1: 91.595,
    y2: 104.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 56.599,
    x2: 45.063,
    y1: 110.564,
    y2: 103.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 35.982,
    x2: 12.652,
    y1: 118.798,
    y2: 180.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationIcon);
export default __webpack_public_path__ + "static/media/confirmationIcon.d8553774943a6e04fe2d3bd0c5f33ddf.svg";
export { ForwardRef as ReactComponent };